(function() { window.GUID_44e7ee59_700b_4882_a01a_872882a8a808 = { getGuid: function() { return "44e7ee59-700b-4882-a01a-872882a8a808"; } }; })();
//namespace CS.App.Views._Shared.WallSections {
//  CS.Controls.Accordion.Events.Ready({
//    selector: "body",
//    childSelector: ".accordion-friendnotifications",
//    callback: function (control, e) {
//      const $accordionHeader = control.$Control.find(".accordion-header");
//      if ($accordionHeader.length > 0) {
//        const $firstChild = $accordionHeader.children().first();
//        $firstChild.css("cursor", "pointer");
//        $accordionHeader.offon(
//          "click.accordion-friendnotifications-headerclicked",
//          (e) => {
//            this.log("Handling click on accordion header...");
//            const $target = $(e.target);
//            const isCheckboxChild =
//              $target.closest(".checkbox.control-cs").length > 0;
//            if (isCheckboxChild) {
//              this.log("Click was on checkbox, aborting.");
//              return;
//            }
//            const $checkbox = $firstChild.find(".checkbox.control-cs");
//            if ($checkbox.length > 0) {
//              this.log(
//                "Click was not on checkbox, triggering checkbox click..."
//              );
//              $checkbox.trigger("click");
//            }
//          }
//        );
//      }
//      CS.Controls.CheckBox.Events.CheckboxValueChanged({
//        selector: "#" + control.ControlId,
//        childSelector: ".checkbox",
//        callback: function (checkBox, e) {
//          e.jqueryEventObject.stopImmediatePropagation();
//          if (checkBox.$Control.hasClass("notif-checkbox-global")) {
//            handleGlobalNotifsCheckboxClick(e, checkBox, control);
//          } else {
//            handleNotifCheckboxClick(e);
//          }
//        },
//      });
//    },
//  });
//  function handleNotifCheckboxClick(
//    e: Controls.IExtraParams<Controls.CheckBox.IValueChangedEventData>
//  ) {
//    CS.Controls.ControlBase.log("Handling notification checkbox click...");
//    let notificationData = e.data
//        .extraData as CS.Controls.FollowedPlayers.FollowedPlayerNotificationCheckboxData,
//      isSubscribed = e.data.value == "true",
//      data = {
//        isSubscribed,
//        notificationSubscriptionId: notificationData.Id,
//        notificationType: notificationData.NotificationType,
//      };
//    CS.Ajax.Post(
//      Url.CSUrl("friendupdatefriendsubscription"),
//      data,
//      (response) => {}
//    );
//  } 
//  function handleGlobalNotifsCheckboxClick(
//    e: Controls.IExtraParams<Controls.CheckBox.IValueChangedEventData>,
//    checkBox: Controls.CheckBox,
//    accordion: Controls.Accordion
//  ) {
//    CS.Controls.ControlBase.log(
//      "Handling global notifications checkbox click..."
//    );
//    let isSubscribed = e.data.value == "true";
//    CS.Controls.ControlBase.log(
//      `isSubscribed: ${isSubscribed}, checkBox.IsChecked: ${checkBox.IsChecked}`
//    );
//    let data = {
//      isSubscribed,
//    };
//    CS.Ajax.Post(Url.CSUrl("friendsubscribetofriend"), data, (response) => {
//      if (isSubscribed) {
//        let $friendSection = $(".friend-section-container");
//        if ($friendSection.length > 0) {
//          $friendSection.toggleClass("is-a-friend", true);
//        }
//      }
//      //   if (checkBox.IsChecked) {
//      //     control.RefreshContent();
//      //   } else {
//      //     control.ExpandCollapse(false);
//      //   }
//      accordion.RefreshContent();
//      //CS.Views.EventWallView?.ToggleNotificationsSubscription(isSubscribed);
//      //const $closestPopup = control.$Control.closest(".popup");
//      //if ($closestPopup.length > 0) {
//      //  const $fetchTrigger = $closestPopup.find(".fetch-trigger");
//      //  if ($fetchTrigger.length > 0) {
//      //    $fetchTrigger.data("is-following", isSubscribed);
//      //    $fetchTrigger.trigger("click");
//      //  }
//      //}
//    });
//  }
//}

//# sourceMappingURL=friend-notifications.js.map
